import { Dispatch } from 'redux';
import { fetchAggregationDetails } from '../../../../services/discovery/fetchAggregationDetails';
import { makeFetchModule } from '../../../_utils';
import { storeAggregations } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeAggregations(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/aggregationDetailsFetching',
    fetchAggregationDetails,
    callbacks
);

export default reducer;
export { fetchData, reset };
